import { render, staticRenderFns } from "./ClientMenu.vue?vue&type=template&id=caf5492e&scoped=true&"
import script from "./ClientMenu.vue?vue&type=script&lang=ts&"
export * from "./ClientMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ClientMenu.vue?vue&type=style&index=0&id=caf5492e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf5492e",
  null
  
)

export default component.exports